/**
 * EVAR Workflow Module.
 *
 * Exports the workflow configuration, services, and components for EVAR sizing.
 */

import { COMMON_LAYOUTS } from '../../common/layouts';
import { createWorkflowConfig } from '../../types';
import { EvarMeasurementsPanel } from './components/evar-measurements-panel';
import { EvarReportPanel } from './components/evar-report-panel';
import { EvarSaveStatus } from './components/evar-save-status';
import { EvarSizingSheet } from './components/evar-sizing-sheet';
import { EvarReportPreview } from './components/report/evar-report-preview';
import { EvarStrategyMain } from './components/strategy/evar-strategy-main';
import { EvarStrategyPanel } from './components/strategy/evar-strategy-panel';
import { EVAR_LAYOUTS } from './layouts/evar-layouts';

export const EVAR_WORKFLOW_CONFIG = createWorkflowConfig({
    workflowId: 'evar',
    layouts: [...COMMON_LAYOUTS, ...EVAR_LAYOUTS],
    panels: { 'evar-sizing-sheet': EvarSizingSheet },
    headerExtra: EvarSaveStatus,
    defaultWindowLevelPresetId: 'angio',
    steps: [
        {
            id: 'measurements',
            title: '1 - Measurements',
            sidebar: EvarMeasurementsPanel,
            mainView: { type: 'layout', layoutName: 'evar-default' },
        },
        {
            id: 'strategy',
            title: '2 - Strategy',
            sidebar: EvarStrategyPanel,
            mainView: { type: 'component', component: EvarStrategyMain },
        },
        {
            id: 'report',
            title: '3 - Report',
            sidebar: EvarReportPanel,
            mainView: { type: 'component', component: EvarReportPreview },
        },
    ],
    defaultStepId: 'measurements',
});

export { EvarWorkflowService } from './services/evar-workflow-service';
export type { DataReadyPayload } from './services/evar-workflow-service';
